































































import { Prop, Component, Vue } from 'vue-property-decorator'
import { Contact } from '@/api/model/contact'

@Component
export default class EditContactForm extends Vue {
    @Prop() readonly value!: Contact
    selectedTab: string = 'basic'

    get validGenders() {
        return Contact.validGenders.map(value => ({ label: this.$t(`gender.${value}`), value }))
    }
}
